import React from 'react';
import STTypo from '../typo/STTypo';
import { Button } from 'antd';
import { ColorOptions } from '../typo/STTypo.models';
import './styles/bodyClusterModalFooterButtons.style.scss';
import { DeleteButtonWithPopover } from './deleteButtonWithPopover';

interface BodyClusterModalFooterButtonsProps {
  clusterId?: string;
  onSubmit: () => void;
  onCancel: () => void;
  isDisabled: boolean;
}

export function BodyClusterModalFooterButtons({ clusterId, onSubmit, onCancel, isDisabled }: BodyClusterModalFooterButtonsProps) {
  return (
    <div className='cluster-modal-footer-buttons'>
      {clusterId && <DeleteButtonWithPopover clusterId={clusterId} />}
      <div className='cluster-modal-footer-buttons__actions' style={{ width: '100%', marginLeft: 'auto' }}>
        <Button onClick={() => onCancel()}>
          <STTypo color={ColorOptions.PRIMARY}>Cancel</STTypo>
        </Button>
        <Button disabled={isDisabled} onClick={() => onSubmit()} type='primary' data-testid='button-add-characteristic-and-indicator-modal'>
          <STTypo>Submit</STTypo>
        </Button>
      </div>
    </div>
  );
}
